exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Nav{background-color:var(--affiliation-registration-header-footer-color)}.Nav>.container{position:relative}.Nav__List{list-style-type:none;display:flex;flex-direction:row;padding:0 .25rem;margin:0}.Nav__List .active{background:#595959;box-shadow:0 7px 0 var(--affiliation-registration-header-footer-color)}@media (min-width:768px){.Nav__List{padding:0}}.Nav__Link{display:none;cursor:pointer;color:var(--affiliation-registration-header-text-color);padding:.5rem;transition:background-color .45s}@media (min-width:768px){.Nav__Link{display:block;padding:8px 30px}}.Nav__Link:hover{background-color:var(--affiliation-registration-next-button-color);color:var(--affiliation-registration-header-text-color);text-decoration:none}.Nav__LanguageButton{margin-left:auto}.Nav li:last-child{display:flex;flex:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?sourceMap!./registration-react/components/Nav/Nav.scss
// module id = 808
// module chunks = 0